import React, { useEffect, useState, useRef } from 'react';
import { motion, useMotionValue, useSpring } from 'framer-motion';
import { shouldReduceExperience } from '../../lib/performance';
type CursorVariant = 'default' | 'button' | 'image';
export function CustomCursor() {
  const [enabled, setEnabled] = useState(false);
  const [variant, setVariant] = useState<CursorVariant>('default');
  const x = useMotionValue(-100);
  const y = useMotionValue(-100);
  const ringX = useSpring(x, {
    stiffness: 350,
    damping: 30,
    mass: 0.6
  });
  const ringY = useSpring(y, {
    stiffness: 350,
    damping: 30,
    mass: 0.6
  });
  const dotRef = useRef<HTMLDivElement>(null);
  const variantRef = useRef<CursorVariant>('default');
  const pendingTarget = useRef<EventTarget | null>(null);
  const frameRef = useRef<number | null>(null);
  useEffect(() => {
    if (!window.matchMedia('(pointer: fine)').matches || shouldReduceExperience()) return;
    setEnabled(true);
    document.documentElement.classList.add('custom-cursor-active');
    const classifyTarget = () => {
      frameRef.current = null;
      const target = pendingTarget.current as HTMLElement | null;
      if (!target) return;
      const nextVariant: CursorVariant = target.closest("[data-cursor='image']") ? 'image' : target.closest("button, a, [data-cursor='button']") ? 'button' : 'default';
      if (nextVariant !== variantRef.current) {
        variantRef.current = nextVariant;
        setVariant(nextVariant);
      }
    };
    const move = (event: MouseEvent) => {
      x.set(event.clientX);
      y.set(event.clientY);
      if (dotRef.current) {
        dotRef.current.style.transform = `translate3d(${event.clientX}px, ${event.clientY}px, 0) translate(-50%, -50%)`;
      }
      pendingTarget.current = event.target;
      if (frameRef.current === null) frameRef.current = requestAnimationFrame(classifyTarget);
    };
    window.addEventListener('mousemove', move, {
      passive: true
    });
    return () => {
      window.removeEventListener('mousemove', move);
      if (frameRef.current !== null) cancelAnimationFrame(frameRef.current);
      document.documentElement.classList.remove('custom-cursor-active');
    };
  }, [x, y]);
  if (!enabled) return null;
  const ringSize = variant === 'button' ? 64 : variant === 'image' ? 90 : 38;
  return <>
      <motion.div aria-hidden className="pointer-events-none fixed left-0 top-0 z-[9999] rounded-full mix-blend-multiply" style={{
      x: ringX,
      y: ringY,
      translateX: '-50%',
      translateY: '-50%',
      width: ringSize,
      height: ringSize,
      border: '1.5px solid rgba(0,87,255,0.7)',
      background: variant === 'image' ? 'radial-gradient(circle, rgba(45,168,255,0.22), transparent 70%)' : variant === 'button' ? 'rgba(45,168,255,0.10)' : 'transparent'
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} data-id="element-89" data-mp="15ef5ro9t08y7" />
      <div ref={dotRef} aria-hidden className="pointer-events-none fixed left-0 top-0 z-[9999] h-2 w-2 rounded-full bg-royal" style={{
      boxShadow: '0 0 12px 2px rgba(0,87,255,0.6)'
    }} data-id="element-90" data-mp="2lodclqthj8no" />
    </>;
}